import { RedirectUrls } from '@cannect/constants/texts'
import { useBrand } from 'hooks/useBrand'
import { useScheduling } from 'hooks/useScheduling'
import Button from 'new-components/Button'
import * as Styled from './styles'
import ContinueYourJourney from 'pages/AppointmentScheduling/ContinueYourJourney'
import AppointmentResume from './AppointmentResume'
import { useHistory } from 'react-router'

function ConclusionStep() {
  const { appointmentFromB2C } = useScheduling()
  const { brand, config } = useBrand()
  const history = useHistory()

  const currentStatus = appointmentFromB2C?.current_status.status_description.name || ''

  const paymentOk = ['paid', 'waiting_appointment'].includes(currentStatus)

  const isAspaec = brand === 'aspaec'
  const isVikura = brand === 'vikura'

  const handleCreateNewAppointment = () => {
    history.push(config.scheduling.path ?? '/agendamento')
    window.location.reload()
  }

  const handleGoToAssociateArea = () => {
    history.push('/AreaAssociados/MinhaConta')
  }

  const buttonStyle = {
    fontFamily: 'Poppins',
    fontWeight: '600',
    backgroundColor: 'var(--app-green-dark, #464F31)'
  }

  return (
    <Styled.Container id="agendamento-conclusao">
      <Styled.Header>{paymentOk ? 'Consulta confirmada!' : 'Consulta pré-agendada!'}</Styled.Header>

      <AppointmentResume />
      <div
        style={{
          display: 'flex',
          gap: 12,
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
        {/* Vikura: contato com a equipe vem primeiro — agendar outra consulta
            é a ação secundária logo depois de confirmar a consulta. */}
        {isVikura && (
          <Button
            style={buttonStyle}
            onClick={() => window.open(RedirectUrls.WHATSAPP_VIKURA_TEAM, '_blank', 'noopener,noreferrer')}>
            Dúvidas? Fale com nossa equipe!
          </Button>
        )}
        <Button style={buttonStyle} onClick={handleCreateNewAppointment}>
          Agendar outra consulta
        </Button>
        {isAspaec && (
          <Button style={buttonStyle} onClick={handleGoToAssociateArea}>
            Área do associado
          </Button>
        )}
      </div>

      <ContinueYourJourney />
    </Styled.Container>
  )
}

export default ConclusionStep
